// @flow

import React from 'react';
import { colors } from 'seedling/constants';
import type { IconWithColor } from './types';

const PaperclipIcon = ({ width, height, className, color }: IconWithColor) => {
  return (
    <svg
      viewBox="0 0 17 17"
      width={width}
      height={height}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        fillRule="nonzero"
        d="M6.355 10.781a.75.75 0 0 1-1.083-1.038L10.585 4.2a1.963 1.963 0 0 1 2.85 0c.766.799.766 2.081.001 2.881L6.26 14.594a3.179 3.179 0 0 1-4.62 0c-1.253-1.31-1.253-3.418 0-4.727l7.5-7.826c1.659-1.73 4.764-1.754 6.386.012 1.608 1.75 1.608 4.952-.011 6.64L10.2 14.236a.75.75 0 1 1-1.083-1.038l5.313-5.543c1.066-1.112 1.066-3.415-.011-4.588-1.027-1.118-3.13-1.102-4.197.012l-7.5 7.825a1.942 1.942 0 0 0 0 2.652c.681.71 1.772.71 2.452 0l7.177-7.511a.595.595 0 0 0 0-.807.464.464 0 0 0-.684 0L6.355 10.78z"
      />
    </svg>
  );
};

PaperclipIcon.defaultProps = {
  width: 17,
  height: 17,
  color: colors.mediumGrey,
};

export default PaperclipIcon;
